export default __webpack_public_path__ + "static/media/Path3413.f4cdf608.svg";